/* Pappy Help Center JS — rebuilt at 1779490836 — salt: b2b9f9aa8f8cfb4e */
/*  Pappy & Co — Help Center client script (v2)
    Filters the article accordion as the user types, with a visible
    "Showing X of 59 articles" counter for clear feedback.
*/
(function () {
  var ARTICLE_SEL = '.pc-help-article';
  var SECTION_SEL = '.pc-help-section';
  var INPUT_ID = 'pc-help-q';
  var COUNTER_ID = 'pc-help-results-count';

  function log() {
    if (window.console && window.console.log) {
      try { window.console.log.apply(window.console, ['[PappyHelp]'].concat([].slice.call(arguments))); }
      catch (e) { /* noop */ }
    }
  }

  function normalize(s) {
    s = (s == null) ? '' : String(s);
    try { s = s.normalize('NFKD'); } catch (e) { /* older browsers */ }
    return s.toLowerCase().replace(/[̀-ͯ]/g, '');
  }

  function setCounter(visible, total, term) {
    var el = document.getElementById(COUNTER_ID);
    if (!el) return;
    if (!term) {
      el.textContent = '';
      el.removeAttribute('data-active');
      return;
    }
    el.setAttribute('data-active', '1');
    if (visible === 0) {
      el.textContent = 'No articles match "' + term + '". Try a different word, or email customerservice@pappyco.com.';
    } else if (visible === total) {
      el.textContent = 'Showing all ' + total + ' articles for "' + term + '".';
    } else {
      el.textContent = 'Showing ' + visible + ' of ' + total + ' articles for "' + term + '".';
    }
  }

  function applyFilter(q) {
    var term = normalize((q || '').trim());
    var articles = document.querySelectorAll(ARTICLE_SEL);
    var sections = document.querySelectorAll(SECTION_SEL);
    var total = articles.length;

    if (!term) {
      for (var i = 0; i < articles.length; i++) {
        articles[i].removeAttribute('open');
        articles[i].style.display = '';
      }
      for (var j = 0; j < sections.length; j++) {
        sections[j].style.display = '';
      }
      setCounter(total, total, '');
      return 0;
    }

    var totalMatches = 0;
    var firstMatch = null;

    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      var secMatches = 0;
      var arts = sec.querySelectorAll(ARTICLE_SEL);
      for (var a = 0; a < arts.length; a++) {
        var art = arts[a];
        var text = normalize(art.textContent || '');
        if (text.indexOf(term) !== -1) {
          art.style.display = '';
          art.setAttribute('open', '');
          secMatches++;
          totalMatches++;
          if (!firstMatch) firstMatch = art;
        } else {
          art.style.display = 'none';
        }
      }
      sec.style.display = secMatches > 0 ? '' : 'none';
    }

    setCounter(totalMatches, total, term);

    // Note: intentionally no auto-scroll. The user typed without expecting
    // their viewport to jump. They can scroll manually to see opened matches.

    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'help_center_search', {
          search_term: term,
          result_count: totalMatches
        });
      } catch (e) { /* noop */ }
    }

    return totalMatches;
  }

  function handleSubmit(ev) {
    if (ev && ev.preventDefault) ev.preventDefault();
    var input = document.getElementById(INPUT_ID);
    applyFilter(input ? input.value : '');
    return false;
  }

  function init() {
    var input = document.getElementById(INPUT_ID);
    if (!input) {
      log('input not found — skipping init');
      return;
    }
    log('init OK, input found, articles=' + document.querySelectorAll(ARTICLE_SEL).length);

    var timer = null;
    input.addEventListener('input', function (e) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { applyFilter(e.target.value); }, 100);
    });

    // Also bind submit on the parent form so Enter doesn't reload the page
    var form = input.closest ? input.closest('form') : null;
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    // Honor ?q= deep-links from search engines / direct nav
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.has('q')) {
        input.value = params.get('q');
        applyFilter(input.value);
      }
    } catch (e) { /* older browsers */ }
  }

  // Expose globally for the form's onsubmit attribute
  window.PappyHelp = { search: handleSubmit, applyFilter: applyFilter };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
